// ============================================================
// Scroll Animations Module - Intersection Observer
// ============================================================

export function initScrollAnimations() {
    // Create intersection observer for fade-in animations
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -100px 0px',
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Add animation class
                entry.target.classList.add('animate-in');
                entry.target.style.animation = 'slideUp 0.6s ease-out forwards';

                // Optional: unobserve after animation to improve performance
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    // Observe all elements with fade-in-section class
    const fadeInElements = document.querySelectorAll('.fade-in-section');
    fadeInElements.forEach(el => {
        el.style.opacity = '0';
        observer.observe(el);
    });

    // ============================================================
    // Parallax Effect for Background Elements
    // ============================================================
    const handleParallax = () => {
        const parallaxElements = document.querySelectorAll('[data-parallax]');

        parallaxElements.forEach(element => {
            const scrollY = window.pageYOffset;
            const speed = parseFloat(element.getAttribute('data-parallax')) || 0.5;
            element.style.transform = `translateY(${scrollY * speed}px)`;
        });
    };

    window.addEventListener('scroll', handleParallax, { passive: true });

    // ============================================================
    // Stagger Animation for Cards
    // ============================================================
    const projectCards = document.querySelectorAll('.project-card');
    projectCards.forEach((card, index) => {
        card.style.opacity = '0';

        const cardObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // Stagger animation with delay
                    setTimeout(() => {
                        entry.target.style.animation = `slideUp 0.6s ease-out ${index * 0.1}s forwards`;
                        entry.target.style.opacity = '1';
                    }, index * 50);

                    cardObserver.unobserve(entry.target);
                }
            });
        }, observerOptions);

        cardObserver.observe(card);
    });
}
